import { render, staticRenderFns } from "./DaysToCopyPopup.vue?vue&type=template&id=95c9952e"
import script from "./DaysToCopyPopup.vue?vue&type=script&lang=ts"
export * from "./DaysToCopyPopup.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports